// app/report/report.js

(function () {
    'use strict';
    var controllerId = 'report';
    angular.module('app').controller(controllerId, ['$rootScope', '$filter', 'datacontext', 'common', 'sectionMenu', '_', 'moment', 'bootstrap.dialog', '$uibModal', '$translate', 'amMoment', 'tmhDynamicLocale', reportFn]);

    function reportFn($rootScope, $filter, datacontext, common, sectionMenu, _, moment, bDialog, $uibModal, $translate, amMoment, tmhDynamicLocale) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        var detectIE = $rootScope.detectIE;
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard 

        var vm = this;
        vm.title = $translate.instant('EsportaDati');
        vm.sectionMenu = sectionMenu.setSection('Report');
        vm.loading == false;

        vm.capoSezione = $rootScope.isAuthorized('CAPOSEZIONE');

        vm.currentLanguage = $translate.proposedLanguage() || $translate.use();     //Forzatura della lingua
        amMoment.changeLocale(vm.currentLanguage);                                  //Forzatura della lingua
        tmhDynamicLocale.set(vm.currentLanguage);                                   //Forzatura della lingua

        //Liste
        vm.list = {};
        vm.list.anni = [];
        vm.list.mesi = [];
        vm.list.giorni = [];
        vm.list.setttimane = [];
        vm.list.aziendePartner = [];

        // Filtro
        vm.filter = {};
        vm.filter.anno = vm.fAnno = 0;
        vm.filter.mese = vm.fMese = 0;
        vm.filter.giorno = vm.fGiorno = 0;
        vm.filter.settimana = vm.fSettimana = 0;
        vm.filter.dipendente = vm.fDipendente = -1; 
        vm.filter.dataInizio = vm.fDataInizio = '';
        vm.filter.dataFine = vm.fDataFine = '';
        vm.filter.commessa = vm.fCommessa = '';
        vm.filter.aziendaPartner = vm.fAziendaPartner = 0;

        //Metodi su interfaccia
        vm.commessaChanged = commessaChanged;
        vm.selezionaDipendente = selezionaDipendente;
        vm.annullaDipendente = annullaDipendente;
        vm.reportMensile = reportMensile;
        vm.reportPresenze = reportPresenze;
        vm.reportCosti = reportCosti;
        vm.reportCommesse = reportCommesse;
        vm.oreDaiTimeSheet = oreDaiTimeSheet;
        vm.reportMensileDipendenti = reportMensileDipendenti;
        vm.reportVerificaTimeSheet = reportVerificaTimeSheet;
        vm.reportTotaliCommSez = reportTotaliCommSez;
        vm.reportTotaliSezDip = reportTotaliSezDip;
        vm.reportTotaliSezioni = reportTotaliSezioni;

        //Configurazione calendario
        vm.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };
        vm.format = 'dd/MM/yyyy';

        vm.open = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened = !vm.opened;
            vm.opened1 = false;
        };

        vm.open1 = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened1 = !vm.opened1;
            vm.opened = false;
        };

        // ---- ACTIVATE -------
        activate();

        function activate() {
            vm.loading = true;
            var promises = [getListAnni(), getListMesi(), getListSettimane(), getListGiorni(), getListAziendePartner()];
            common.activateController(promises, controllerId).then(function () {
                var d = new Date();
                vm.fAnno = d.getFullYear();
                vm.fMese = d.getMonth() + 1;                
                vm.loading = false;
            });
        }

        //****************************************************
        // METODI 
        //****************************************************        
        function setFilter() {            
            vm.filter.anno = vm.fAnno == null ? 0 : vm.fAnno;
            vm.filter.mese = vm.fMese == null ? 0 : vm.fMese;
            vm.filter.settimana = vm.fSettimana == null ? 0 : vm.fSettimana;
            vm.filter.giorno = vm.fGiorno == null ? 0 : vm.fGiorno;
            vm.filter.commessa = vm.fCommessa == null ? -1 : vm.fCommessa;
            vm.filter.cdc = vm.fCdc == null ? 0 : vm.fCdc;
            vm.filter.dipendente = vm.fDipendenteId == null ? -1 : vm.fDipendenteId;        
            vm.filter.dataInizio = vm.fDataInizio == null ? '' : $filter('date')(vm.fDataInizio, 'dd/MM/yyyy');
            vm.filter.dataFine = vm.fDataFine == null ? '' : $filter('date')(vm.fDataFine, 'dd/MM/yyyy');
            vm.filter.commessa = vm.fCommessa == null ? '' : vm.fCommessa;
            vm.filter.aziendaPartner = vm.fAziendaPartner == null ? 0 : vm.fAziendaPartner;
        }

        function reportMensile(bPDF) {
            setFilter();

            if (vm.loading == true)
                return;

            if (!vm.filter.anno || !vm.filter.mese) {
                logError($translate.instant('Indicare anno e mese'));
                return;
            }   

            if (vm.filter.dipendente == -1) {
                logError($translate.instant('SelezionaUnDipendente'));
                return;
            }

            vm.loading = true;
            datacontext.report_getTimeSheetMensile(bPDF, vm.filter.dipendente, vm.filter.anno, vm.filter.mese).then(function (data) {
                if (data && data.url) {
                    var a = document.createElement("a");
                    //var data_type = 'data:application/vnd.ms-excel,';
                    a.setAttribute('style', 'display:none');
                    a.setAttribute("target", "_blank");
                    if (bPDF) 
                        //var data_type = 'data:application/pdf';

                    document.body.appendChild(a);
                    a.href = data.url;
                    a.download = data.file;
                    a.click();
                    document.body.removeChild(a);
                }
                else
                    logError($translate.instant('Impossibile scaricare il file'));

                vm.loading = false;
            });
        }

        function reportMensileDipendenti(bPDF) {
            setFilter();

            if (vm.loading == true)
                return;

            if (!vm.filter.anno || !vm.filter.mese) {
                logError($translate.instant('Indicare anno e mese'));
                return;
            }   

            vm.loading = true;
            datacontext.report_getTimeSheetMensileDipendenti(bPDF, -1, vm.filter.anno, vm.filter.mese, vm.filter.aziendaPartner).then(function (data) {
                if (data && data.url) {
                    var a = document.createElement("a");
                    var data_type = 'data:application/vnd.ms-excel,';
                    a.setAttribute('style', 'display:none');
                    a.setAttribute("target", "_blank");
                    if (bPDF) 
                        var data_type = 'data:application/pdf';

                    document.body.appendChild(a);
                    a.href = data.url;
                    a.download = data.file;
                    a.click();
                    document.body.removeChild(a);
                }
                else
                    logError($translate.instant('Impossibile scaricare il file'));

                vm.loading = false;
            });
        }

        function reportPresenze(bPDF) {
            setFilter();            
            if (vm.loading == true)
                return;            

            if (!vm.filter.anno || !vm.filter.mese) {
                logError($translate.instant('Indicare anno e mese'));
                return;
            }                

            vm.loading = true;
            datacontext.report_getPresenze(bPDF, vm.filter.anno, vm.filter.mese, vm.filter.aziendaPartner).then(function (data) {
                if (data && data.url) {
                    var a = document.createElement("a");
                    var data_type = 'data:application/vnd.ms-excel,';
                    a.setAttribute('style', 'display:none');
                    a.setAttribute("target", "_blank");
                    if (bPDF)
                        var data_type = 'data:application/pdf';

                    document.body.appendChild(a);
                    a.href = data.url;
                    a.download = data.file;
                    a.click();
                    document.body.removeChild(a);
                }
                else
                    logError($translate.instant('Impossibile scaricare il file'));

                vm.loading = false;
            });
        }

        function reportCosti(bPDF) {
            setFilter();
            if (vm.loading == true)
                return;
            //Stampa l'errore ("Indicare anno e mese o data inizio e data fine")
            if ((!vm.filter.anno || !vm.filter.mese) && (!vm.filter.dataInizio && !vm.filter.dataFine)) {
                logError($translate.instant('Indicare anno e mese'),$translate.instant('o'), $translate.instant('DataInizio'), $translate.instant('e'), $translate.instant('DataFine'));   
                return;
            }            

            vm.loading = true;
            datacontext.report_getCosti(bPDF, vm.filter.anno, vm.filter.mese, vm.filter.dataInizio, vm.filter.dataFine, vm.filter.aziendaPartner).then(function (data) {
                if (data && data.url) {
                    var a = document.createElement("a");
                    var data_type = 'data:application/vnd.ms-excel,';
                    a.setAttribute('style', 'display:none');
                    a.setAttribute("target", "_blank");
                    if (bPDF)
                        var data_type = 'data:application/pdf';

                    document.body.appendChild(a);
                    a.href = data.url;
                    a.download = data.file;
                    a.click();
                    document.body.removeChild(a);
                }
                else
                    logError($translate.instant('Impossibile scaricare il file'));

                vm.loading = false;
            });
        }

        function reportCommesse(bPDF) {
            setFilter();
            if (vm.loading == true)
                return;
            
            if (!vm.filter.anno && !vm.filter.commessa && vm.filter.dipendente == -1) {
                logError($translate.instant('IndicareLaCommessaAnnoOIlDipendente'));
                return;
            }

            vm.loading = true;
            datacontext.report_getCommesse(bPDF, vm.filter.commessa, vm.filter.anno, vm.filter.mese, vm.filter.dataInizio, vm.filter.dataFine, vm.filter.dipendente, vm.filter.aziendaPartner).then(function (data) {
                if (data && data.url) {
                    var a = document.createElement("a");
                    var data_type = 'data:application/vnd.ms-excel,';
                    a.setAttribute('style', 'display:none');
                    a.setAttribute("target", "_blank");
                    if (bPDF)
                        var data_type = 'data:application/pdf';

                    document.body.appendChild(a);
                    a.href = data.url;
                    a.download = data.file;
                    a.click();
                    document.body.removeChild(a);
                }
                else
                    logError($translate.instant('Impossibile scaricare il file'));

                vm.loading = false;
            });
        }

        function reportVerificaTimeSheet(bPDF) {
            setFilter();
            if (vm.loading == true)
                return;

            if (!vm.filter.anno || !vm.filter.mese) {
                logError($translate.instant('Indicare anno e mese'));
                return;
            }

            vm.loading = true;
            datacontext.report_getVerificaTimeSheet(bPDF, vm.filter.anno, vm.filter.mese).then(function (data) {
                if (data && data.url) {
                    var a = document.createElement("a");
                    var data_type = 'data:application/vnd.ms-excel,';
                    a.setAttribute('style', 'display:none');
                    a.setAttribute("target", "_blank");
                    if (bPDF)
                        var data_type = 'data:application/pdf';

                    document.body.appendChild(a);
                    a.href = data.url;
                    a.download = data.file;
                    a.click();
                    document.body.removeChild(a);
                }
                else
                    logError($translate.instant('Impossibile scaricare il file'));

                vm.loading = false;
            });
        }

        function reportTotaliCommSez(bPDF) {
            setFilter();
            if (vm.loading == true)
                return;

            vm.loading = true;
            datacontext.report_getTotaliCommSez(bPDF, vm.filter.anno, vm.filter.mese, vm.filter.dataInizio, vm.filter.dataFine).then(function (data) {
                if (data && data.url) {
                    var a = document.createElement("a");
                    var data_type = 'data:application/vnd.ms-excel,';
                    a.setAttribute('style', 'display:none');
                    a.setAttribute("target", "_blank");
                    if (bPDF)
                        var data_type = 'data:application/pdf';

                    document.body.appendChild(a);
                    a.href = data.url;
                    a.download = data.file;
                    a.click();
                    document.body.removeChild(a);
                }
                else
                    logError($translate.instant('Impossibile scaricare il file'));

                vm.loading = false;
            });
        }

        function reportTotaliSezDip(bPDF) {
            setFilter();
            if (vm.loading == true)
                return;

            vm.loading = true;
            datacontext.report_getTotaliSezDip(bPDF, vm.filter.anno, vm.filter.mese, vm.filter.dataInizio, vm.filter.dataFine).then(function (data) {
                if (data && data.url) {
                    var a = document.createElement("a");
                    var data_type = 'data:application/vnd.ms-excel,';
                    a.setAttribute('style', 'display:none');
                    a.setAttribute("target", "_blank");
                    if (bPDF)
                        var data_type = 'data:application/pdf';

                    document.body.appendChild(a);
                    a.href = data.url;
                    a.download = data.file;
                    a.click();
                    document.body.removeChild(a);
                }
                else
                    logError($translate.instant('Impossibile scaricare il file'));

                vm.loading = false;
            });
        }

        function reportTotaliSezioni(bPDF) {
            setFilter();
            if (vm.loading == true)
                return;

            /*if ((!vm.filter.anno || !vm.filter.mese) && (!vm.filter.dataInizio && !vm.filter.dataFine)) {
                logError('Indicare anno e mese o data inizio e data fine');
                return;
            }*/

            vm.loading = true;
            datacontext.report_getTotaliSezioni(bPDF, vm.filter.anno, vm.filter.mese, vm.filter.dataInizio, vm.filter.dataFine).then(function (data) {
                if (data && data.url) {
                    var a = document.createElement("a");
                    var data_type = 'data:application/vnd.ms-excel,';
                    a.setAttribute('style', 'display:none');
                    a.setAttribute("target", "_blank");
                    if (bPDF)
                        var data_type = 'data:application/pdf';

                    document.body.appendChild(a);
                    a.href = data.url;
                    a.download = data.file;
                    a.click();
                    document.body.removeChild(a);
                }
                else
                    logError($translate.instant('Impossibile scaricare il file'));

                vm.loading = false;
            });
        }

        // Selezione dipendente
        function selezionaDipendente() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/dipendente/modal/dipendenteSelect.html?version=30',
                controller: 'dipendenteSelect',
                windowClass: 'modal-wide',
                resolve: {}
            });

            modalInstance.result.then(function (returnItem) {
                vm.fDipendenteId = returnItem.id;
                vm.strDipendente = returnItem.nominativo;
            });
        }

        function annullaDipendente() {
            vm.fDipendenteId = -1;
            vm.strDipendente = '';
        }


        function getListAnni() {
            vm.list.anni = [];
            var item = {
                'Id': 0,
                'Name': $translate.instant('--Tutti--')
            };
            vm.list.anni.push(item);

            for (var i = 0; i < 90; i++) {
                var item = {
                    'Id': 2010 + i,
                    'Name': String(2010 + i)
                };
                vm.list.anni.push(item);
            }

            vm.filter.anno = vm.fAnno = new Date().getFullYear();
        }

        function getListMesi() {
            vm.list.mesi = [
                { 'Id': 0, 'Name': $translate.instant('--Tutti--') },
                { 'Id': 1, 'Name': $translate.instant('Gennaio') },
                { 'Id': 2, 'Name': $translate.instant('Febbraio') },
                { 'Id': 3, 'Name': $translate.instant('Marzo') },
                { 'Id': 4, 'Name': $translate.instant('Aprile') },
                { 'Id': 5, 'Name': $translate.instant('Maggio') },
                { 'Id': 6, 'Name': $translate.instant('Giugno') },
                { 'Id': 7, 'Name': $translate.instant('Luglio') },
                { 'Id': 8, 'Name': $translate.instant('Agosto') },
                { 'Id': 9, 'Name': $translate.instant('Settembre') },
                { 'Id': 10, 'Name': $translate.instant('Ottobre') },
                { 'Id': 11, 'Name': $translate.instant('Novembre') },
                { 'Id': 12, 'Name': $translate.instant('Dicembre') }
            ];

            vm.filter.mese = vm.fMese = new Date().getMonth() + 1;            
            meseChanged();
        }

        function getListSettimane() {
            vm.list.settimane = [];
            var item = {
                'Id': 0,
                'Name': $translate.instant('--Tutte--')
            };
            vm.list.settimane.push(item);

            for (var i = 1; i < 55; i++) {
                var item = {
                    'Id': i,
                    'Name': String(i)
                };
                vm.list.settimane.push(item);
            }
        }

        function getListGiorni() {
            vm.list.giorni = [];
            var item = {
                'Id': 0,
                'Name': $translate.instant('--Tutti--')
            };
            vm.list.giorni.push(item);

            for (var i = 1; i < 32; i++) {
                var item = {
                    'Id': i,
                    'Name': String(i)
                };
                vm.list.giorni.push(item);
            }
        }

        function getListSettimane() {
            vm.list.settimane = [];
            var item = {
                'Id': 0,
                'Name': $translate.instant('--Tutte--')
            };
            vm.list.settimane.push(item);

            for (var i = 1; i < 55; i++) {
                var item = {
                    'Id': i,
                    'Name': String(i)
                };
                vm.list.settimane.push(item);
            }
        }

        function getListCommesse() {
            vm.list.commesse = [];
            var commessaZero = {
                'AreaId': 0,
                'Cliente': '',
                'Descrizione': 'Costi indiretti',
                'Id': 0
            }

            vm.list.commesse = [];
            vm.list.commesse.push(commessaZero);

            return datacontext.commessa_getAllByFilter(0, 0, '', -1, -1, '').then(function (data) {
                if (Array.isArray(data) && data.length > 0)
                    data.forEach(function (item) { vm.list.commesse.push(item); });

                return vm.list.commesse;
            });
        }

        function commessaChanged(id) {
            vm.fCdc = 0;
            if (id == null) {
                vm.list.cdc = getListCentriCosto(-1);
            }
            else {
                var commessa = _.find(vm.list.commesse, { 'Id': id });
                vm.list.cdc = getListCentriCosto(commessa.Id);
            }
        }

        function meseChanged() {
            switch (vm.fMese) {
                case 1:
                    vm.strMese = 'Gennaio';
                    break;
                case 2:
                    vm.strMese = 'Febbraio';
                    break;
                case 3:
                    vm.strMese = 'Marzo';
                    break;
                case 4:
                    vm.strMese = 'Aprile';
                    break;
                case 5:
                    vm.strMese = 'Maggio';
                    break;
                case 6:
                    vm.strMese = 'Giugno';
                    break;
                case 7:
                    vm.strMese = 'Luglio';
                    break;
                case 8:
                    vm.strMese = 'Agosto';
                    break;
                case 9:
                    vm.strMese = 'Settembre';
                    break;
                case 10:
                    vm.strMese = 'Ottobre';
                    break;
                case 11:
                    vm.strMese = 'Novembre';
                    break;
                case 12:
                    vm.strMese = 'Dicembre';
                    break;
            }
        }

        function getListCentriCosto(commessaId) {
            vm.list.cdc = [];
            return datacontext.centroCosto_getAllList(commessaId, -1).then(function (data) {
                return vm.list.cdc = data;
            });
        }

        function getListAziendePartner() {
            return datacontext.aziendaPartner_getAllList().then(function (data) {
                return vm.list.aziendePartner = data;
            });
        }

        function oreDaiTimeSheet() {
            setFilter();           
            if (vm.loading == true)
                return;

            if (vm.filter.settimana > 0) {
                vm.filter.mese = vm.filter.giorno = 0;
                vm.fMese = vm.fGiorno = 0;
            }

            if (!vm.filter.anno || !vm.filter.settimana) {
                logError($translate.instant('IndicareAnnoESettimana'));
                return;
            }   

            vm.loading = true;
            datacontext.reportOre_getAll(0, 0, vm.filter.anno, vm.filter.mese, vm.filter.settimana, vm.filter.giorno, vm.filter.commessa, vm.filter.ricerca, vm.filter.aziendaPartner, vm.ordine).then(function (data) {
                // Header
                var excel = "<table>";
                excel += "<tr><td>Dipendente</td><td>Commessa</td><td>Commessa Desc</td><td>Cliente</td><td>Attivita'</td><td>Data</td>";
                excel += "<td>Giorno</td><td>Mese</td><td>Anno</td><td>Ore Lavoro</td><td>Status Ore</td><td>Note</td><td>Settimana</td></tr>";

                // Row Vs Column
                var rowCount = 1;
                data.forEach(function (item) {
                    excel += "<tr>";
                    excel += ("<td>" + String(item.Dipendente) + "</td>").replace('null', '');
                    excel += ("<td>" + String(item.Commessa) + "</td>").replace('null', '');
                    excel += ("<td>" + String(item.CommessaDesc) + "</td>").replace('null', '');
                    excel += ("<td>" + item.Cliente + "</td>").replace('null', '');
                    excel += ("<td>" + item.Attivita + "</td>").replace('null', '');
                    excel += ("<td>" + $filter('dateFromValues')(item.Giorno, item.Mese, item.Anno) + "</td>").replace('null', '');
                    excel += ("<td>" + item.Giorno + "</td>").replace('null', '');
                    excel += ("<td>" + item.Mese + "</td>").replace('null', '');
                    excel += ("<td>" + item.Anno + "</td>").replace('null', '');
                    excel += ("<td>" + $filter('floatToString')(item.OreLavoro) + "</td>").replace('null', '');
                    excel += ("<td>" + item.StatusOre + "</td>").replace('null', '');
                    excel += ("<td>" + item.Note + "</td>").replace('null', '');
                    excel += ("<td>" + item.Settimana + "</td>").replace('null', '');
                    rowCount++;
                    excel += '</tr>';
                });
                excel += '</table>'

                var excelFile = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:x='urn:schemas-microsoft-com:office:excel' xmlns='http://www.w3.org/TR/REC-html40'>";
                excelFile += "<head>";
                excelFile += "<!--[if gte mso 9]>";
                excelFile += "<xml>";
                excelFile += "<x:ExcelWorkbook>";
                excelFile += "<x:ExcelWorksheets>";
                excelFile += "<x:ExcelWorksheet>";
                excelFile += "<x:Name>";
                excelFile += vm.fSettimana > 0 ? vm.strMese + " " + vm.fAnno + " Sett. " + vm.fSettimana : vm.strMese + " " + vm.fAnno;
                excelFile += "</x:Name>";
                excelFile += "<x:WorksheetOptions>";
                excelFile += "<x:DisplayGridlines/>";
                excelFile += "</x:WorksheetOptions>";
                excelFile += "</x:ExcelWorksheet>";
                excelFile += "</x:ExcelWorksheets>";
                excelFile += "</x:ExcelWorkbook>";
                excelFile += "</xml>";
                excelFile += "<![endif]-->";
                excelFile += "</head>";
                excelFile += "<body>";
                excelFile += excel.replace("null", "");
                excelFile += "</body>";
                excelFile += "</html>";
                var base64data = "base64," + $.base64.encode(excelFile);
                var a = document.createElement("a");
                var data_type = 'data:application/vnd.ms-excel,';
                a.setAttribute('style', 'display:none');
                a.setAttribute("target", "_blank");
                document.body.appendChild(a);
                var byteCharacters = atob(base64data.replace("base64,", ""));
                var byteNumbers = new Array(byteCharacters.length);
                for (var i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                var byteArray = new Uint8Array(byteNumbers);
                var blob = new Blob([byteArray], { type: 'application/vnd.ms-excel' });
                var URL = window.URL || window.webkitURL;
                var downloadUrl = URL.createObjectURL(blob);
                a.href = downloadUrl;
                a.download = vm.fSettimana > 0 ? vm.strMese + " " + vm.fAnno + " Sett " + vm.fSettimana : vm.strMese + " " + vm.fAnno + '.xls';
                a.click();
                document.body.removeChild(a);
                vm.loading = false;
            });
        }

    }
})();
